<app-impact-toolbar [title]="'DEPENDENCY_TREE.MAIN_TITLE'">
  <app-impact-tree-toolbar class="top"></app-impact-tree-toolbar>

  <nav mat-tab-nav-bar [tabPanel]="tabPanel" class="second">
    <button mat-tab-link [active]="true" q9Track="DEPENDENCY_TREE.TREE_VIEW">
      {{ 'DEPENDENCY_TREE.TREE_VIEW' | translate }}
    </button>
    <button
      mat-tab-link
      q9Track="DEPENDENCY_TREE.GRID_VIEW"
      [q9Track]="'DEPENDENCY_TREE.GRID_VIEW'"
      [ngClass]="{'switch-control-disabled': user.role === 'view'}"
      (click)="openGridView({data: this.treeData})"
      [disabled]="user.role === 'view'"
      [matTooltip]="'DEPENDENCY_TREE.NO_PERMISSION_TO_GRID_VIEW' | translate"
      [matTooltipDisabled]="user.role !== 'view'">
      {{ 'DEPENDENCY_TREE.GRID_VIEW_TITLE' | translate }}
    </button>
  </nav>
  <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
</app-impact-toolbar>

<mat-sidenav-container class="content" autosize>
  <q9-blur-wrapper
    [class.full-height]="true"
    [blur]="isFree()"
    [title]="'DEPENDENCY_TREE.PAYWALL_TREE_TITLE'"
    [text]="'DEPENDENCY_TREE.PAYWALL_TREE_SUBTITLE'">
    <app-impact-tree
      *ngIf="treeData"
      [treeData]="treeData"
      (loadChildren)="loadNodeChildren($event)"
      (labelLeftClick)="labelClicked($event)"
      (labelRightClick)="openContextMenu($event)"
      (labelHover)="showRelationDescription($event)"
      (labelMouseLeave)="hideRelationDescription = true"></app-impact-tree>
  </q9-blur-wrapper>

  <mat-sidenav *ngIf="!isFree()" mode="side" position="end" disableClose="true" opened>
    <div class="no-permission-container" *ngIf="!hasAccessToRefModel">
      {{'SIDEBAR.REF_MODEL_NO_ACCESS' | translate}}
    </div>

    <app-sidebar-wrapper
      *ngIf="hasAccessToRefModel"
      [impactTreeRootNode]="node"
      [isDependencyTree]="true"></app-sidebar-wrapper>
  </mat-sidenav>

  <mat-dialog-content
    class="tree-description-popover k-popup q9-popover-container"
    [style.left]="descriptionPopupPosition.x"
    [style.top]="descriptionPopupPosition.y"
    [style.visibility]="hideRelationDescription ? 'hidden' : 'visible'">
    <mat-label class="tree-content-title">
      {{ 'CORE.ATTACHMENTS.RELATIONSHIP_DESCRIPTION_LABEL' | translate }}
    </mat-label>
    <p class="tree-content-text-block" [innerHTML]="relationDescription | formatDescription"></p>
  </mat-dialog-content>

  <div
    #contextMenuTrigger
    class="mat-trigger"
    [style.left]="contextMenuPosition.x"
    [style.top]="contextMenuPosition.y"
    [matMenuTriggerFor]="contextMenu"></div>

  <mat-menu #contextMenu="matMenu" id="node-menu">
    <div class="spinner" *ngIf="contextLoading">
      <mat-spinner diameter="25"></mat-spinner>
    </div>
    <ng-template matMenuContent class="menu-items-container" let-node="node">
      <div *ngIf="!contextLoading">
        <span
          mat-menu-item
          *ngIf="canOpenDependencyTree"
          (click)="openDependencyTree(node.data)"
          q9Track="DEPENDENCY_TREE.CONTEXT_MENU.OPEN_DEPENDENCY_TREE">
          {{ 'ATTACHMENTS.OPEN_DEPENDENCY_TREE' | translate }}
        </span>
        <span
          class="inline"
          mat-menu-item
          *ngIf="canOpenGridView"
          (click)="openGridView(node)"
          q9Track="DEPENDENCY_TREE.CONTEXT_MENU.OPEN_GRID_VIEW">
          {{ 'DEPENDENCY_TREE.OPEN_GRID_VIEW' | translate }}
        </span>
        <span
          mat-menu-item
          *ngIf="canAddStory"
          [matMenuTriggerFor]="dependencyOutcome"
          [matMenuTriggerData]="{node: node}">
          {{ 'CONTEXT_MENU.ADD_TO_STORY' | translate }}
        </span>
      </div>
    </ng-template>
  </mat-menu>

  <mat-menu #dependencyOutcome="matMenu">
    <ng-template matMenuContent class="menu-items-container" let-menuNode="node">
      <span class="menu-description" (click)="$event.stopPropagation()">
        {{ 'CONTEXT_MENU.CHOOSE_OUTCOME' | translate }}
      </span>
      <button
        [matTooltip]="'CORE.CHANGES.NO_LICENSE_TITLE' | translate"
        [matTooltipDisabled]="hasChangeTicketsLicense()"
        [disabled]="!hasChangeTicketsLicense()"
        mat-menu-item
        (click)="addNodeToStory(updateOutcome, menuNode)"
        q9Track="DEPENDENCY_TREE.CONTEXT_MENU.ADD_TO_STORY.UPDATE">
        {{ 'CORE.ATTACHMENTS.UPDATE' | translate }}
      </button>
      <button
        mat-menu-item
        [matTooltip]="'CORE.CHANGES.NO_LICENSE_TITLE' | translate"
        [matTooltipDisabled]="hasChangeTicketsLicense()"
        [disabled]="!hasChangeTicketsLicense()"
        (click)="addNodeToStory(deleteOutcome, menuNode)"
        q9Track="DEPENDENCY_TREE.CONTEXT_MENU.ADD_TO_STORY.DELETE">
        {{ 'CORE.ATTACHMENTS.DELETE_BTN' | translate }}
      </button>
    </ng-template>
  </mat-menu>
</mat-sidenav-container>
